// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container___sGiv","errorText":"ErrorPage_errorText__Bc5by","buttonWrapper":"ErrorPage_buttonWrapper__1M-pi"};